module.exports = __webpack_public_path__ + "static/media/ic-warehouse.a63beeaf.svg";